import React, { useEffect, useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { FaCloudUploadAlt, FaFileCsv } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
  } from "@mui/material";

const UploadCableData = () => {
  const [uploading, setUploading] = useState(false);
  const [authByToken, setAuthByToken] = useState('');
  const [file, setFile] = useState(null);
  const [errorUpload, setErrorUpload] = useState("");
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openInputSuccess, setOpenInputSuccess] = useState(false);
  const [openInputFail, setOpenInputFail] = useState(false);
  const [description, setDescription] = useState('');
  const [error, setError] = useState("");
  const resource = "operation/upload-cable-data";
    
    useEffect(() => {
      const storedToken = localStorage.getItem("token");
  
      const checkSessionToken = async () => {
        try {
          const response = await fetch(
            `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                authorization: 'Basic eGNwOk50dGkyMDI0IQ==',
              },
            }
          );
  
          if (!response.ok) {
            setError(data.message || "Failed to fetch session token data");
            throw new Error(data.message || "Failed to fetch session token data");
          }
  
          // Parse response text as a boolean value
          const text = await response.text();
          const data = text === "true";
  
          if (data) {
          } else {
            window.alert("Session is invalid");
            navigate("/login");
          }
        } catch (error) {
          console.error("Fetch Error:", error.message);
          setError("Fetch Error: " + error.message);
        }
      };

      if (storedToken) {   
        loadUserByToken(storedToken);
      }
  
      checkSessionToken();
    }, []);

    const loadUserByToken = async (token) => {
      const result = await axios.get(`https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/find-by-token?token=${token}`, {
              headers: {
                authorization: 'Basic eGNwOk50dGkyMDI0IQ==',
              },
            });   
      setAuthByToken(result.data[0])
    }

    function getLocalDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0'); // Bulan dimulai dari 0
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  const navigate = useNavigate();

  const fileTypes = ["text/csv", "application/vnd.ms-excel"];
  const maxSize = 10 * 1024 * 1024; // 10MB

  const onDrop = useCallback((acceptedFiles) => {
    const selectedFile = acceptedFiles[0];
    setErrorUpload(null); // Clear previous error

    if (!fileTypes.includes(selectedFile.type)) {
      setErrorUpload("Invalid file type, upload a CSV format");
      setFile(null);
      return;
    }

    if (selectedFile.size > maxSize) {
      setErrorUpload("File size exceeds 10MB, please upload file size below 10MB");
      return;
    }

    if (!selectedFile) {
      setErrorUpload("No file selected");
      return;
    }

    setFile(selectedFile);
    setErrorUpload("");
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: fileTypes.join(","),
    multiple: false,
  });

  function isValidFileName(fileName) {
    const regex = /^[a-zA-Z0-9 ._-]+$/;
    return regex.test(fileName);
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setUploading(true);
    const localDateNow = getLocalDate();

          try {
            // Step 1: Get the presigned URL from the backend     
            const response = await axios.get(
              `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/operation/upload-cable-data?fileName=${file.name}&uploadDate=${localDateNow}`, {
              headers: {
                authorization: 'Basic eGNwOk50dGkyMDI0IQ==',
              },
            });
      
            if (response.status === 200) {
              const uploadUrl = response.data.uploadUrl;
      
              // Step 2: Upload the file to S3 using the presigned URL
              const responseUploadS3 = await axios.put(uploadUrl, file, {              
                headers: {
                  "Content-Type": file.type,
                },
                // headers: {}
              });

              if (responseUploadS3.status === 200) {
                    setOpenConfirm(false)
                    // setOpenInputSuccess(true)
                    await inputUploadData(localDateNow)
                } else {
                    setOpenConfirm(false)
                    setOpenInputFail(true)
                }
            } else {
                setError("File upload failed: " + response.message);
              }
            } catch (err) {
              setError("File upload failed");
              console.error("File upload failed", err);
            } finally {
              setUploading(false);
            }   
  };

  async function inputUploadData(localDateNow){
          const dataUpload = {
            fileName: file.name,
            description : description,
            uploadDate : localDateNow,
            createBy : authByToken.xcp_internal_email,
          }
      
            try {
              const response = await fetch(
                "https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/operation/input-data-upload",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    authorization: 'Basic eGNwOk50dGkyMDI0IQ==',
                  },
                  body: JSON.stringify(dataUpload),
                }
              );
      
              const data = await response.json();
              const responseBody = JSON.parse(data.body);
              if (!response.ok) {
                setError(data.message || "Failed to submit form");
                throw new Error(data.message || "Failed to submit form");
              }
      
              const { message} = responseBody;
              if (message == "success") {
                setOpenConfirm(false)
                setOpenInputSuccess(true)
              } else {
                setOpenConfirm(false)
                setOpenInputFail(true)
              }
            } catch (error) {
              console.error("Submission Error:", error.message);
              setError("Submission Error: " + error.message);
            }
  }

  const handleClose = () => {
    setOpenConfirm(false);
    setOpenInputFail(false)
  };

  function inputSuccess(){
    navigate("/operation/data-upload-list")
  }

  const handleConfirmation = async (event) => {
    event.preventDefault();
    if (!file) {
      setOpenConfirm(false);
      setErrorUpload("Please upload a valid file");
      return;
    }

    if (file && !isValidFileName(file.name)) {
      setOpenConfirm(false);
      setErrorUpload("File name contains special characters. Please use only letters or numbers");
      return;
    }

    setOpenConfirm(true);
  };

  function getCurrentDate() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Bulan dimulai dari 0
    const day = String(now.getDate()).padStart(2, '0');

    return `${day}/${month}/${year}`;
}

  return (
    <div className="container-order-list">
         <h1>Cross Connect Upload Cable Data</h1>
         {error && <p className="error-message">{error}</p>}
          <div className="upload-cable-data">
          <form onSubmit={handleConfirmation}>
            <div className="csv-upload">
              {/* <label>Upload Cable Data</label> */}
              <h5>Upload Cable Data</h5>
                <div className="upload-date">
                        <label htmlFor="orderDate">Upload Date</label>
                        <input 
                        style={{
                          paddingLeft: "10px",
                          color: "black"
                          }} 
                        type="text" 
                        id="orderDate"            
                        value={getCurrentDate()}  
                        required
                        disabled
                        />
                  </div> 
              <div {...getRootProps()} className="dropzone">
                <input {...getInputProps()} />
                <FaCloudUploadAlt size={50} color="#007bff" />
                <p>Drag and drop a CSV file (max 10MB) here, or click to select one</p>
              </div>
              {file && (
                <div className="file-info">
                  <FaFileCsv size={40} color="#28a745" />
                  <p>{file.name}</p>
                </div>
              )}
              {errorUpload && <p className="error-message">{errorUpload}</p>}
              
            </div>

            <div className="upload-installation"> 
                  <div className="textbox">
                    <label htmlFor="Note">Description</label>
                    <textarea
                    value={description} 
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder='Description'       
                    ></textarea>  
                  </div>
                </div>
                <button type="submit" className="upload-button" disabled={uploading}>
                    {uploading ? "Uploading..." : "Upload"}
                  </button>  
          </form>
      </div>
    
        <Dialog open={openConfirm}>
                <DialogTitle>{"Are you sure you want to upload this cable data?"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Clicking "Yes" will upload this cable data.
                        </DialogContentText>
                    </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        No
                    </Button>
                    <Button onClick={handleSubmit} color="primary" autoFocus>
                        Yes
                    </Button>
                </DialogActions>
                </Dialog> 
                <Dialog open={openInputSuccess}>
                <DialogTitle>{"Upload cable data successfully"}</DialogTitle>
                <DialogActions>
                    <Button onClick={inputSuccess} color="primary" autoFocus>
                    Ok
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={openInputFail}>
                <DialogTitle>{"Upload cable data failed"}</DialogTitle>
                <DialogActions>
                <Button onClick={handleClose} color="primary" autoFocus>
                    Ok
                </Button>
                </DialogActions>
            </Dialog>
    </div>
    
  );
};

export default UploadCableData;
